<template>
  <div class="filter-product">

    <!-- ORDER -->
    <div class="item"
         v-if="sortData.name != null"
         :class="[{active : sortData.selected != 0}]"
    >
      <div class="title_dd" @click="openFilter(sortData)">
        <span>{{sortData.name}}<span v-if="sortData.selected != 0"> : {{sortData.selected}}</span></span>
        <svg
            :class="[{opened : item_open_code == sortData.code}]"
            xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
          <path d="M3 4L0 0L6 4.03788e-07L3 4Z" fill="#222222"/>
        </svg>
      </div>
      <div class="list" v-show="item_open_code == sortData.code">
        <div
            class="item" v-for="variant in sortData.values" :key="variant"
            @click="setSort(variant)"
            :class="[{active: variant.name == sortData.name}]"
        >
          <span class="sort_type_text">{{variant.name}}</span>
        </div>
      </div>
    </div>
    <!-- ORDER -->

    <!-- PRICE -->
    <div class="item price"
         :class="[{active : price_item.selected != 0}]"
    >
      <div class="title_dd" @click="openFilter(price_item)">
        <span>{{price_item.name}}<span v-if="price_item.selected != 0"> : {{price_item.selected}}</span></span>
        <svg
            :class="[{opened : item_open_code == price_item.code}]"
            xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
          <path d="M3 4L0 0L6 4.03788e-07L3 4Z" fill="#222222"/>
        </svg>
      </div>
      <div class="list" v-show="item_open_code == price_item.code">
        <div class="inputs">
          <span>от: </span>
          <input
              placeholder="0"
              :value="priceData.min_price" type="number" min="0" @input="changePrice('min', $event.target.value)">
          <span>до: </span>
          <input
              placeholder="1000"
              :value="priceData.max_price" type="number" min="0" @input="changePrice('max', $event.target.value)">
        </div>
      </div>
    </div>
    <!-- PRICE -->

    <!-- FILTER -->
    <div class="item"
         :class="[{active : item.selected != 0}]"
         v-for="item in filterData" :key="item"
    >
      <div class="title_dd" @click="openFilter(item)">
        <span>{{item.name}}<span v-if="item.selected != 0"> : {{item.selected}}</span></span>
        <svg
            :class="[{opened : item_open_code == item.code}]"
            xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
          <path d="M3 4L0 0L6 4.03788e-07L3 4Z" fill="#222222"/>
        </svg>
        <span class="sep" v-show="item.selected != 0"></span>
        <svg @click="filterCheckboxClear(item)" v-show="item.selected != null" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M9 1.00005L1 9M9 8.99995L1 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="list" v-show="item_open_code == item.code">
        <div class="item"
             :class="[{active: variant.checked}]"
             v-for="variant in item.values" :key="variant"
        >
          <standart-checkbox
              :id="variant.id"
              :checked="variant.checked"
              @change="filterCheckboxSelect(item, variant, $event)"
          >
            <template v-slot:text_content><span v-html="variant.name"></span></template>
          </standart-checkbox>
        </div>
      </div>
    </div>
    <!-- FILTER -->

    <button class="clear_filter" @click="filterAllClear()">Очистить фильтр</button>

  </div>



  <div class="filter-product-mobile">
    <div class="filter">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12.5459 1.33333H3.45411C2.29467 1.33333 1.6031 2.61036 2.24625 3.56375L6.06071 8.55162C6.37866 9.02295 6.54833 9.57674 6.54833 10.1432V13.9479C6.54833 14.587 7.33016 14.907 7.78741 14.4551L9.23908 13.0205C9.3752 12.886 9.45167 12.7035 9.45167 12.5133V10.1432C9.45167 9.57674 9.62134 9.02295 9.93929 8.55162L13.7538 3.56375C14.3969 2.61036 13.7053 1.33333 12.5459 1.33333Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>ФИЛЬТР</span>
    </div>
    <div class="sort">
      <span>По убыванию наличия</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="4" viewBox="0 0 6 4" fill="none">
        <path d="M3 4L0 0L6 4.03788e-07L3 4Z" fill="#222222"/>
      </svg>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import StandartCheckbox from "@/components/share/StandartCheckbox";
export default {
  name: 'FilterProduct',
  props : {
    filterData : Object,
    priceData : Object,
    sortData : Object
  },
  components: {
    StandartCheckbox
  },
  data() {
    return{
      price_item: {
        selected : 0,
        code : "PRICE",
        name : "Цена",
        cMin: 0,
        cMax: 0,
        chTm: null,
      },
      item_open_code: ""
    }
  },
  methods : {

    changePrice : function(type, value) {
      if(type == "min") {
        this.price_item.cMin = value;
      }
      if(type == "max") {
        this.price_item.cMax = value;
      }

      this.price_item.chTm = clearTimeout(this.price_item.chTm);

      var $this = this;
      this.price_item.chTm = setTimeout(function(){
        $this.setPriceInQuery();
      }, 2000);
    },
    setPriceInQuery : function() {
      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              page: this.$route.query.page,
              filter: this.$route.query.filter,
              sort: this.$route.query.sort,
              price: this.price_item.cMin+"__"+this.price_item.cMax,
            }
          }
      );
    },
    setSort : function(variant) {
      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              page: this.$route.query.page,
              filter: this.$route.query.filter,
              sort: variant.code,
              price: this.$route.query.price,
            }
          }
      );

      this.item_open_code = "close_sort";
    },
    openFilter : function(item) {
      if(this.item_open_code == item.code || this.item_open_code == "clear") {
        this.item_open_code = "";
      }
      else {
        this.item_open_code = item.code;
      }
    },
    filterCheckboxSelect : function(item, variant, $event) {
      variant.checked = $event;

      item.selected = null;
      item.values.forEach(function (vari) {
        if(vari.checked) {
          item.selected++;
        }
      });

      this.setFilterInQuery();
    },
    filterCheckboxClear : function(item) {
      item.selected = 0;
      item.values.forEach(function (vari) {
        vari.checked = false;
      });

      this.item_open_code = "clear";

      this.setFilterInQuery();
    },
    filterAllClear : function () {
      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              page: this.$route.query.page,
              filter: "clear",
            }
          }
      );
    },
    setFilterInQuery : function() {
      let filterQuery = "y&";

      var cFilter = {};

      this.filterData.forEach(function(item) {
        item.values.forEach(function(vari) {
          if(vari.checked) {
            if(!Object.prototype.hasOwnProperty.call(cFilter, item.code)) {
              cFilter[ item.code] = [];
            }
            cFilter[item.code].push(vari.name);
          }
        });
      });

      filterQuery = JSON.stringify(cFilter);

      this.$router.push(
          {
            query: {
              q: this.$route.query.q,
              page: this.$route.query.page,
              filter: filterQuery,
            }
          }
      );
    },
  }
}
</script>

<style scoped>

.filter-product {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 28px;
}

.item {
  cursor: pointer;
  position: relative;
}

.item .title_dd {
  display: flex;
  gap: 6px;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 8px 12px;
}

.item.active .title_dd {
  background: var(--Blue, #1B78BC);
}

.item .title_dd span{
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;

}

.item .title_dd svg {

}

.item .title_dd svg.opened {
  transform: rotate(180deg);
}

.item.active .title_dd span{
  color: var(--White);
}

.item.active .title_dd .sep{
  width: 1px;
  height: 18px;
  opacity: 0.2;
  background: #FFF;
  margin-left: 8px;
  margin-right: 8px;
}

.item.active .title_dd svg path{
  fill: var(--White);
}

.list {
  background: var(--White);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0px 6px 50px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow: auto;
  position: absolute;
  top: 40px;
  width: max-content;
  min-width: 200px;
  z-index: 10;
}

.list span.sort_type_text {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  display: block;
  width: 100%;
}

.list .item.active span {
  color: var(--Blue);
}

.list span.sort_type_text:hover {
  color: var(--Blue);
}

.list::-webkit-scrollbar {
  width: 8px; /* Ширина всего элемента навигации */
}

.list::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.list::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 8px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

.item.price {

}

.item.price .list .inputs {
  display: flex;
  gap: 8px;
  border: 1px solid var(--Border);
  padding: 8px;
  border-radius: 8px;
  justify-content: space-between;
}

.item.price .list .inputs span {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
}

.item.price .list .inputs input{
  border: none;
  outline: none;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  display: block;
  width: 100px;
}

.clear_filter {
  color: var(--Blue, #1B78BC);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0px 12px;
}

.filter-product-mobile {
  display: none;
  margin-bottom: 20px;
  justify-content: space-between;
}

.filter {
  display: flex;
  gap: 8px;
  align-items: center;
}

.filter span{
  color: #000;
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 15.6px */
  letter-spacing: 0.26px;
  text-transform: uppercase;
  border-bottom: 1px dotted #000;
  padding-bottom: 2px;
}

.filter-product-mobile .sort {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .filter-product {
    /*display: none;*/
  }

  .filter-product-mobile {
    /*display: flex;*/
  }

  .filter-product {
    flex-direction: column;
  }
}
</style>



<style>
.list .item.active .text_content {
  color: var(--Blue);
}

.list .item:hover .text_content {
  color: var(--Blue);
}

.list .item:hover .text_content {
  color: var(--Blue);
}
</style>
